import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { GetRelationshipNotesListResponseBodySchema } from "../schemas";
export const url = (queryParams) => {
    let qsString = "";
    const advisorId = queryParams?.advisorId;
    const clientId = queryParams?.clientId;
    if (queryParams !== null) {
        const params = new URLSearchParams();
        if (queryParams.page !== undefined) {
            params.append("page", queryParams.page.toString());
        }
        if (queryParams.limit !== undefined) {
            params.append("limit", queryParams.limit.toString());
        }
        if (queryParams.sortBy !== undefined) {
            params.append("sortBy", queryParams.sortBy.toString());
        }
        if (queryParams.sortOrder !== undefined) {
            params.append("sortOrder", queryParams.sortOrder.toString());
        }
        if (queryParams.dateFrom !== undefined) {
            params.append("dateFrom", queryParams.dateFrom.toISOString());
        }
        if (queryParams.dateTo !== undefined) {
            params.append("dateTo", queryParams.dateTo.toISOString());
        }
        if (queryParams.search !== undefined) {
            params.append("search", queryParams.search);
        }
        qsString = `?${params.toString()}`;
    }
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/advisor/${advisorId}/client/${clientId}/notes${qsString}`
        : `https://middleware.uat.farther.com/entity/advisor/${advisorId}/client/${clientId}/notes${qsString}`;
};
const getRelationshipNotesList = async (params, config) => {
    const { data } = await axios.get(url(params), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            Version: "20250619",
        },
    });
    const decoded = GetRelationshipNotesListResponseBodySchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getRelationshipNotesList] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default getRelationshipNotesList;
//# sourceMappingURL=getRelationshipNotesList.js.map